module.exports = __webpack_public_path__ + "static/media/ios-search.58de3086.svg";